
import { Vue, Component, Model, Watch } from 'vue-property-decorator';

import RequestItemLayout from './RequestItemLayout.vue';
import RequestDoctor from './RequestDoctor.vue';
import StepInputDuration from '@/components/calendar/StepInputDuration.vue';
import BaseButton from '@/components/buttons/BaseButton.vue';

import { humanizeToRussian } from '@/utils/date/human';

import { ConsultationRequest } from '@/types/consultations';
import { getSlots } from '@/api/calendar';
import { BackendWorkingDay } from '@/api/calendar/backend';
import responseHandler from '@/store/modules/responseHandler';
import { getConsultationCalculated } from '@/api/consultations';

@Component({
    components: {
        RequestItemLayout,
        RequestDoctor,
        StepInputDuration,
        BaseButton,
    }
})
export default class RequestItemEdit extends Vue {
    @Model('update:request', { required: true }) request!: ConsultationRequest

    @Watch('doctor')
    async onDoctorChange() {
        if (this.request.type === 'Консультация на дому') {
            await this.updateClinic();
            this.calculatePrice();
        }
    }

    clinicId = 0;

    get doctor() {
        return this.request.doctor;
    }

    set doctor(doctor) {
        if (doctor) {
            const request = {
                ...this.request,
                doctor,
            };

            this.updateRequest(request);

            this.$emit('update:doctor', doctor.id);
        }
    }

    get duration() {
        return this.request.duration ?? 15;
    }

    set duration(duration) {
        this.updateRequest({
            ...this.request,
            duration,
        });

        this.$emit('update:duration', duration);
    }

    get humanDuration() {
        if (this.request.duration) {   
            return humanizeToRussian(this.request.duration);
        }

        return '';
    }

    async updateClinic() {
        if (!this.doctor?.id || !this.request.time) {
            return;
        }

        try {
            const slot = await getSlots({
                doctorId: this.doctor.id,
                range: { start: this.request.time?.start.split(' ')[0], end: this.request.time?.end.split(' ')[0] },
            });
    
            const slotKeys = Object.keys(slot);
            const firstKey = slotKeys[0];
            const day = slot[firstKey] as BackendWorkingDay | BackendWorkingDay[] | undefined;

            if (Array.isArray(day)) {
                this.clinicId = day[0]?.clinicId || 0;
            } else {
                this.clinicId = day?.clinicId || 0;
            }
        } catch (error) {
            throw new Error(error);
        }
    }

    async calculatePrice() {
        if (!this.doctor?.id) {
            return;
        }

        try {
            const price = await getConsultationCalculated(
                2,
                +this.doctor.id,
                this.request.specialization?.id as number,
                this.request.patient?.id as number,
                this.clinicId,
            );

            this.request.price = price;
        } catch (clientError) {
            responseHandler.cancelRedirectToNotFound();
            responseHandler.showNotify({ message: clientError?.response?.data?.message || clientError, type: 'fail' });
        }
    }

    updateRequest(request: ConsultationRequest) {
        this.$emit('update:request', request);
    }

    cancelSelection() {
        this.$emit('cancel');

        this.doctor = null;
    }

    confirmRequest() {
        this.$emit('confirm', this.request);
    }

    mounted() {
        this.$el.scrollIntoView({
            block: 'nearest',
            behavior: 'smooth',
        })
    }
}
